var _a, _b;
const CSRF = (window == null ? void 0 : window.csrf) || ((_a = window == null ? void 0 : window.Bynder) == null ? void 0 : _a.csrf_token) || ((_b = document.querySelector('meta[name="x-csrf-token"]')) == null ? void 0 : _b.getAttribute("content")) || "";
const headers = {
  "Content-Type": "application/json; charset=UTF-8",
  "cache-control": "no-cache",
  "X-csrf-token": CSRF || ""
};
const ENDPOINTS = {
  User: "/v7/identity/users/current_user/",
  InboxToken: "/api/1/notifications/inbox/issue-token",
  LegacyCountNew: "/notifications/user_notifications/?count_new=true",
  LegacyNotifications: "/notifications/user_notifications/",
  DeleteNotification: (notification_id) => `/notifications/user_notifications/${notification_id}`,
  DeleteAllNotifications: () => `/notifications/user_notifications/`,
  MarkAsReadNotification: "/notifications/read/"
};
const API = {
  getInboxToken: async () => {
    const response = await fetch(ENDPOINTS.InboxToken, { headers });
    if (!response.ok) {
      throw new Error(`Failed to fetch token: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data.token) {
      throw new Error("Failed to fetch token. No token found in response");
    }
    return data.token;
  },
  getLegacyNotifications: async () => {
    const response = await fetch(ENDPOINTS.LegacyNotifications, { headers });
    if (!response.ok) {
      throw new Error(`Failed to fetch legacy notifications: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data.notifications) {
      throw new Error(
        "Failed to fetch legacy notifications. No notifications found in response"
      );
    }
    return (data == null ? void 0 : data.notifications) || [];
  },
  hasNewLegacyNotifications: async () => {
    const response = await fetch(ENDPOINTS.LegacyCountNew, { headers });
    if (!response.ok) {
      throw new Error(
        `Failed to see if there are new legacy notifications: ${response.statusText}`
      );
    }
    const data = await response.json();
    if ((data == null ? void 0 : data.count) > 0) {
      console.log("There are new legacy notifications", data);
      return true;
    }
    console.log("No new legacy notifications", data);
    return false;
  },
  deleteLegacyNotifications: async (notification_id) => {
    const response = await fetch(ENDPOINTS.DeleteNotification(notification_id), {
      method: "DELETE",
      credentials: "include",
      headers
    });
    if (!response.ok) {
      throw new Error(
        `Failed to delete legacy notification notification_id: ${notification_id}`
      );
    }
    return notification_id;
  },
  markAsReadLegacyNotification: async (notification_id) => {
    const response = await fetch(ENDPOINTS.MarkAsReadNotification, {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ notification_id })
    });
    if (!response.ok) {
      throw new Error(`Failed to mark legacy notification ID: ${notification_id} as read`);
    }
    return notification_id;
  }
};
export {
  API,
  ENDPOINTS
};
//# sourceMappingURL=api.js.map
